export default {
  items: [
    {
      name: 'Home',
      url: '/',
      icon: 'icon-home'
    },
    {
      name: 'Story',
      url: '/story',
      icon: 'icon-book-open'
    } // ,
    // {
    //   name: 'Data',
    //   url: '/data',
    //   icon: 'icon-chart'
    // },
    // {
    //   name: 'Model',
    //   url: '/model',
    //   icon: 'icon-graph'
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js